<div [class.opened]="mobileMenuOpen" class="mobile-menu user-select-none">
    <ul class="list-group">
        <li class="list-group-item">
            Menu <span (click)="mobileMenuOpen = !mobileMenuOpen" class="icon-close_white"></span>
        </li>
        <li (click)="goHome()" class="list-group-item">
            <div class="icon-home"></div>
            Home
        </li>
        <li class="list-group-item">
            <div class="icon-search"></div>
            Zoeken
        </li>
        <li
            [routerLink]="['/', Routenames.settings, { via: Routenames.customers + '/' + customer.id }]"
            class="list-group-item">
            <div class="icon-settings"></div>
            Instellingen
        </li>
    </ul>
</div>
<div class="navbar-mobile user-select-none">
    <i (click)="mobileMenuOpen = !mobileMenuOpen" class="fas fa-bars"></i> <span>{{ customer.name }}</span>
</div>
<div class="customer-details">
    <div class="content pb-0">
        <mat-form-field>
            <mat-select [formControl]="fcFilter" placeholder="Filter gebieden">
                @for (option of areaFilterOptions; track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    @if (selectedCustomer) {
        <div class="content pt-0">
            <h4>{{ selectedAreaName }}</h4>
            <h5>{{ selectedCustomer.status ?? 'Geen status' }}</h5>
            <div class="icons">
                <div class="icon">
                    <i class="fa fa-road"></i>
                    <span>{{ (selectedCustomer.roadLengthKm | number: '0.0-0') ?? '-' }} km </span>
                </div>
                <div class="icon">
                    <i class="fa fa-truck"></i>
                    <span>{{ (selectedCustomer.distanceFromUtrechtKm | number: '0.0-0') ?? '-' }} km </span>
                </div>
                <div class="icon">
                    <i class="fa fa-file-contract"></i><span>{{ firstContract.typeOfTender ?? '-' }}</span>
                </div>
                <div class="icon">
                    <i class="fa fa-calendar-times"></i>
                    <span>{{ firstContract.monthsUntilTender ?? 'Onbekend' }} maanden </span>
                </div>
                <div class="icon">
                    <i class="fa fa-euro-sign"></i>
                    <span>{{ (firstContract.contractValue | number: '0.0-0') ?? '-' }} </span>
                </div>
                <div class="icon">
                    <i class="fa fa-comments"></i>
                    <span>{{ selectedCustomer.remarks && selectedCustomer.remarks.length > 3 ? 'Ja' : 'Nee' }} </span>
                </div>
            </div>
            @if (selectedCustomer.remarks && selectedCustomer.remarks.length > 3) {
                <div class="text">
                    <b>Opmerkingen Diane</b><br />
                    <div [innerHTML]="selectedCustomer.remarks | nl2br"></div>
                </div>
            }
        </div>
    } @else {
        <div class="content pt-0">
            <h4>Klik op een gebied op de kaart</h4>
        </div>
    }
</div>
@if (customer) {
    <div class="near-searchbar user-select-none customer-details-visible">
        <div class="logo-small float-end" routerLink="/"></div>
        @if (filteredPolygons?.length === 0) {
            <div class="loading">De kaart wordt geladen...</div>
        }
        <google-map #googleMap height="100vh" [mapTypeId]="mapTypeId" [options]="options" width="100%">
            @for (polygon of filteredPolygons; track polygon) {
                <map-polygon
                    (polygonClick)="polygonClick(polygon)"
                    [paths]="polygon.exteriorRing"
                    [options]="polygon"></map-polygon>
            }
        </google-map>
        <div class="legend">
            @for (status of statussen; track status) {
                <div>
                    <div [style.background-color]="status.color" class="color"></div>
                    <div>{{ status.name }}</div>
                </div>
            }
        </div>
    </div>
}
